import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export { default } from "react-slick";
export type { Settings } from "react-slick";
